import IAPIResult from "models/IAPIResult";
import { IUserInfo } from "models/IUserInfo";
import IEquipment from "models/sql/IEquipment";
import IFireDepartment from "models/sql/IFireDepartment";
import IHealthRiskAssessment from "models/sql/IHealthRiskAssessment";
import IOpportunity from "models/sql/IOpportunity";
import ISalesRep from "models/sql/ISalesRep";
import { fetchGetAsync, fetchPostAsync } from "utilities/Fetch";

const SERVICE_PATH = "Misc";

export default class MiscService {
    static async reverseAddressLookupAsync(accessToken: string, latitude: string, longitude: string): Promise<string | null> {
        const result: IAPIResult<string> =
            await fetchGetAsync<IAPIResult<string>>(
                `/api/${SERVICE_PATH}/reverseAddressLookup`,
                { latitude, longitude },
                accessToken);

        return result.success ? result.data : null;
    }

    static async emailFormLinkAsync(accessToken: string, emailAddress: string, url: string, formName: string): Promise<string | null> {
        const result: IAPIResult<string> =
            await fetchGetAsync<IAPIResult<string>>(
                `/api/${SERVICE_PATH}/emailFormLink`,
                { emailAddress, url, formName },
                accessToken);

        return result.success ? result.data : null;
    }

    static async sendEmailRawAsync(accessToken: string, emailAddress: string, fromEmailAddress: string, title: string, body: string): Promise<string | null> {
        const result: IAPIResult<string> =
            await fetchPostAsync<IAPIResult<string>>(
                `/api/${SERVICE_PATH}/sendEmailRaw`,
                { emailAddress, fromEmailAddress, title, body },
                accessToken);

        return result.success ? result.data : null;
    }

    static async verifyDashboardTokenAsync(dashboardToken: string = ""): Promise<string | null> {
        const result: IAPIResult<string> =
            await fetchGetAsync<IAPIResult<string>>(
                `/api/${SERVICE_PATH}/verifyDashboardToken`,
                { dashboardToken });

        return result.success ? result.data : null;
    }

    static async GetRepPortalDataAsync(accessToken: string): Promise<{ rep: ISalesRep, opportunities: IOpportunity[], hras: IHealthRiskAssessment[], airCards: IEquipment[], demos: IEquipment[] } | null> {
        const result: IAPIResult<{ rep: ISalesRep, opportunities: IOpportunity[], hras: IHealthRiskAssessment[], airCards: IEquipment[], demos: IEquipment[] }> =
            await fetchGetAsync<IAPIResult<{ rep: ISalesRep, opportunities: IOpportunity[], hras: IHealthRiskAssessment[], airCards: IEquipment[], demos: IEquipment[] }>>(
                `/api/${SERVICE_PATH}/getRepPortalData`,
                {},
                accessToken);

        return result.success ? { rep: result.data.rep, opportunities: result.data.opportunities, hras: result.data.hras, airCards: result.data.airCards, demos: result.data.demos } : null;
    }

    static async GetDeptPortalDataAsync(accessToken: string): Promise<{ dept: IFireDepartment, hras: IHealthRiskAssessment[], airCards: IEquipment[] } | null> {
        const result: IAPIResult<{ dept: IFireDepartment, hras: IHealthRiskAssessment[], airCards: IEquipment[] }> =
            await fetchGetAsync<IAPIResult<{ dept: IFireDepartment, hras: IHealthRiskAssessment[], airCards: IEquipment[] }>>(
                `/api/${SERVICE_PATH}/getDeptPortalData`,
                {},
                accessToken);

        return result.success ? { dept: result.data.dept, hras: result.data.hras, airCards: result.data.airCards } : null;
    }

    static async requestDashboardAccessAsync(email: string): Promise<string | null> {
        const result: IAPIResult<string> =
            await fetchGetAsync<IAPIResult<string>>(
                `/api/${SERVICE_PATH}/requestDashboardAccess`,
                { email });

        return result.success ? result.data : null;
    }

    static async getUserInfoAsync(accessToken: string): Promise<IUserInfo | null> {
        const result: IAPIResult<IUserInfo> =
            await fetchGetAsync<IAPIResult<IUserInfo>>(
                `/api/${SERVICE_PATH}/getUserInfo`,
                {},
                accessToken);

        return result.success ? result.data : null;
    }
}